import type {ExtractPropsWithoutRef} from '@/types';

import {Skeleton as SkeletonUI} from '@travel-frontend/ui-components';

export const Skeleton = (
  props: Omit<ExtractPropsWithoutRef<typeof SkeletonUI>, 'variant'>
) => <SkeletonUI {...props} variant="rect" />;
